interface ApiErrorData {
  detail?: string | Array<string | { msg?: string }>
  message?: string
}

interface ApiErrorLike {
  response?: {
    data?: ApiErrorData | Blob
  }
}

function isBlob (value: unknown): value is Blob {
  return typeof Blob !== 'undefined' && value instanceof Blob
}

function messageFromDetail (detail: ApiErrorData['detail']): string | null {
  if (typeof detail === 'string' && detail.trim()) {
    return detail
  }

  if (Array.isArray(detail) && detail.length > 0) {
    const first = detail[0]
    if (typeof first === 'string' && first.trim()) {
      return first
    }
    if (typeof first === 'object' && first !== null && typeof first.msg === 'string' && first.msg.trim()) {
      return first.msg
    }
  }

  return null
}

function messageFromPayload (payload: ApiErrorData): string | null {
  return messageFromDetail(payload.detail) ??
    (typeof payload.message === 'string' && payload.message.trim() ? payload.message : null)
}

export function getApiErrorMessage (error: unknown, fallback: string): string {
  const data = (error as ApiErrorLike).response?.data

  if (data == null || isBlob(data)) {
    return fallback
  }

  return messageFromPayload(data) ?? fallback
}

export async function getApiErrorMessageAsync (error: unknown, fallback: string): Promise<string> {
  const data = (error as ApiErrorLike).response?.data

  if (isBlob(data)) {
    try {
      const parsed = JSON.parse(await data.text()) as ApiErrorData
      return messageFromPayload(parsed) ?? fallback
    } catch {
      return fallback
    }
  }

  return getApiErrorMessage(error, fallback)
}
